import React, { useState, useEffect } from 'react';
import './PromoBanner.css';

export default function PromoBanner({ language = 'en', onLanguageChange }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const messages = [
    {
      en: "Limited time offer: Get 20% off for two months with code STORY20",
      de: "Zeitlich begrenztes Angebot: 20% Rabatt für zwei Monate mit Code STORY20"
    },
    {
      en: "New: Create stories in German & English 🇩🇪 🇬🇧",
      de: "Neu: Erstelle Geschichten auf Deutsch & Englisch 🇩🇪 🇬🇧"
    },
    {
      en: "PayPal payment coming soon! 💳",
      de: "PayPal-Zahlung kommt bald! 💳"
    }
  ];

  const currentMessage = messages[currentIndex][language] || messages[currentIndex].en;

  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % messages.length);
        setIsTransitioning(false);
      }, 300); // Transition duration
    }, 3000); // 3 seconds per message

    return () => clearInterval(interval);
  }, [messages.length]);

  const handlePrevious = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex((prev) => (prev - 1 + messages.length) % messages.length);
      setIsTransitioning(false);
    }, 300);
  };

  const handleNext = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex((prev) => (prev + 1) % messages.length);
      setIsTransitioning(false);
    }, 300);
  };

  const toggleLanguage = () => {
    if (onLanguageChange) {
      const newLanguage = language === 'en' ? 'de' : 'en';
      onLanguageChange(newLanguage);
    }
  };

  return (
    <div className="promo-banner">
      <button 
        className="promo-nav-button left" 
        onClick={handlePrevious}
        aria-label="Previous message"
      >
        ←
      </button>
      
      <div className={`promo-message ${isTransitioning ? 'fade-out' : 'fade-in'}`}>
        {currentMessage}
      </div>
      
      <button 
        className="promo-nav-button right" 
        onClick={handleNext}
        aria-label="Next message"
      >
        →
      </button>

      {onLanguageChange && (
        <button
          className="language-toggle-button"
          onClick={toggleLanguage}
          aria-label="Toggle language"
        >
          {language === 'en' ? '🇬🇧 EN' : '🇩🇪 DE'}
        </button>
      )}
    </div>
  );
}
